import useWindowSize from "./useWindowSize"

export default function useIsMobile() {
  const [windowWidth] = useWindowSize()
  return windowWidth <= 1024-1
}
